import React from 'react';
import MediaQuery from 'react-responsive';

import Desktop from './Desktop';
import Mobile from './Mobile';


const Component = () => (
  <div className="main">
    <MediaQuery minWidth={769}>
      <Desktop />
    </MediaQuery>
    <MediaQuery maxWidth={768}>
      <Mobile />
    </MediaQuery>
  </div>
);

Component.displayName = "Contact";

export default Component;



// WEBPACK FOOTER //
// ./src/views/Contact/index.js